// extracted by mini-css-extract-plugin
export default {"emoji":"FeedbackBox_emoji__oCLCf","buttonText":"FeedbackBox_buttonText__82b5s"};